import { Directive, Input, ElementRef, ComponentFactoryResolver, ViewContainerRef, HostListener } from '@angular/core';
import { WithLoaderComponent } from './with-loader.component';

@Directive({
  selector: '[appWithLoader]'
})

export class WithLoaderDirective {
  loaderComponent: WithLoaderComponent;
  originalDisplayProperty:string;
  @Input() set appWithLoader(items: any[]) {
    if(this.loaderComponent){
      this.loaderComponent.isLoading = false;
      this._element.nativeElement.style.display =  this.originalDisplayProperty;
    }
  }
  @HostListener("click", ["$event"])
  public onListenerTriggered(event: any): void {
    if(!this.loaderComponent){
      let componentFactory = this._componentResolver.resolveComponentFactory(WithLoaderComponent);
      let componentRef = this._viewContainerRef.createComponent(componentFactory);
      this.loaderComponent = componentRef.instance;
    }
    this.originalDisplayProperty = this._element.nativeElement.style.display;
    this._element.nativeElement.style.display = "none";
    this.loaderComponent.isLoading = true;
}
  constructor(private _element: ElementRef,
    private _componentResolver: ComponentFactoryResolver,
    private _viewContainerRef: ViewContainerRef, ) {}


}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/with-loader/with-loader.directive.ts